import * as React from 'react';
import { cn } from '../utils/cn';

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export function EmptyState({ icon, title, description, action, className, ...props }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-3xl border border-dashed border-[var(--color-border-strong)] bg-[var(--color-surface-muted)] px-6 py-16 text-center',
        className,
      )}
      {...props}
    >
      {icon ? (
        <span className="flex size-14 items-center justify-center rounded-full bg-brand-100 text-brand-600">
          {icon}
        </span>
      ) : null}
      <h3 className="font-display text-lg font-semibold">{title}</h3>
      {description ? (
        <p className="max-w-md text-sm text-[var(--color-foreground-muted)]">{description}</p>
      ) : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
